import { render } from "./PanelEditor.vue?vue&type=template&id=aca1505e&scoped=true&ts=true"
import script from "./PanelEditor.vue?vue&type=script&lang=ts"
export * from "./PanelEditor.vue?vue&type=script&lang=ts"

import "./PanelEditor.vue?vue&type=style&index=0&id=aca1505e&scoped=true&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca1505e"]])

export default __exports__